import { css, Interpolation } from '@emotion/react';
import { saveAs } from 'file-saver';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Button, IconButton } from '@frontend/design-system';
import { buttonStyle } from './common-styles';

export interface DownloadAllActionProps {
  attachments: TeamChatTypes.Attachment[];
}

export const DownloadAllAction = ({ attachments }: DownloadAllActionProps) => {
  const { t } = useTranslation('team-chat');

  const onClickDownloadAll = () => {
    attachments.forEach(({ url, title, type }) => {
      if (type === 'giphy') return;
      return saveAs(url, title);
    });
  };

  if (attachments.length === 0) return null;

  return (
    <Button
      variant='secondary'
      onClick={onClickDownloadAll}
      css={buttonStyle}
      trackingId='team-chat-2.0-download-all-attachments-button'
      hoverLabel={t('Download All')}
    >
      <Icon size={24} name='download' />
    </Button>
  );
};

export interface DownloadButtonProps {
  trackingId?: string;
  title?: string;
  show?: boolean;
  url: string;
  css?: Interpolation;
}

// Why the component here?
// So that all the download buttons can be imported from one place, that's it

export const DownloadButton = ({ url, show, title, ...rest }: DownloadButtonProps) => {
  const { t } = useTranslation('team-chat');

  if (!show) return null;

  return (
    <IconButton
      label={t('Download {{file}}', { file: title })}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        saveAs(url, title);
      }}
      size='xsmall'
      trackingId='team-chat-2.0-download-pdf-thumbnail'
      {...rest}
      css={[downloadButtonStyle, rest.css]}
    >
      <Icon name='download-small' />
    </IconButton>
  );
};

const downloadButtonStyle = css`
  background-color: var(--fabric-color-neutral-00);
  padding: var(--fabric-space-padding-xxs);
`;
